import template from './installation.html'
import css from './installation.css'
import { InstallationController } from './installation.controller.js'

export const InstallationComponent = {
  template: template,
  controller: InstallationController,
  controllerAs: 'InstallationController',
  require:{
  	parentSimulator: '^^simulatorComponent'
  },
  bindings: {
    resource: '=',
    valide: '='
  }
}



// WEBPACK FOOTER //
// ./src/client/pages/simulator/components/installation/installation.component.js